/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListOfScheduleSiteChangeRequestAssignmentDto } from '../listOfScheduleSiteChangeRequestAssignmentDto.schema';

export const ChangeRequestByDateRangeDto = zod.object({
  "id": zod.string().uuid().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "coordinatorId": zod.string().uuid().optional(),
  "sscrSiteAssignments": zod.lazy(() => ListOfScheduleSiteChangeRequestAssignmentDto).optional()
});

export type ChangeRequestByDateRangeDto = zod.input<typeof ChangeRequestByDateRangeDto>;
export type ChangeRequestByDateRangeDtoOutput = zod.output<typeof ChangeRequestByDateRangeDto>;
